import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { Button, Input } from 'antd';
import Highlighter from 'react-highlight-words';
import { SearchOutlined } from '@ant-design/icons';
import translation from '../../../../utils/translation';
import localStorage from '../../../../utils/localStorage';
import { NOTIFICATIONS } from '../../../../commons/api.js';
import StyledTable from "../../../../commons/styles/table.js";

const MaximoNotification = (props) => {
  const [maximoNotification, setMaximoNotification] = useState([]);
  const [searchText, setSearchText] = useState('');
  const searchInput = useRef(null);

  useEffect(() => {
    getMaximoList();
  }, []);

  const getMaximoList = () => {
    const SiteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const headers = {
      method: 'GET',
      url: `${NOTIFICATIONS.GET}?SiteId=${SiteId}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    };
    
    axios(headers)
      .then((response) => {
        setMaximoNotification(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={translation(props.translationCache, `Search`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          
          style={{ width: 90, marginRight: 8 }}
        >
          {translation(props.translationCache, 'Search')}
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}
          
          type='primary'
          danger
          style={{ width: 90 }}
        >
          {translation(props.translationCache, 'Reset')}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record && record[dataIndex] && record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });

  const maximoCol = [
    {
      title: 'Created Time',
      dataIndex: 'CreatedTime',
      key: 'CreatedTime'
    },
    {
      title: 'Data Time',
      dataIndex: 'DataTime',
      key: 'DataTime'
    },
    {
      title: 'Device',
      dataIndex: 'Device Name',
      key: 'Device Name'
    },
    {
      title: 'Parameter Code',
      dataIndex: 'Fault Code',
      key: 'Fault Code',
      ...getColumnSearchProps('DeviceCode')
    },
    {
      title: 'State',
      dataIndex: 'State',
      key: 'State'
    },
    {
      title: 'Status',
      dataIndex: 'AMS Status',
      key: 'AMS Status'
    },
    {
      title: 'Tag Value',
      dataIndex: 'TagValue',
      key: 'TagValue'
    },
    {
      title: 'Maximo Response Date',
      dataIndex: 'Maximo Response Date',
      key: 'Maximo Response Date'
    },
    {
      title: 'Ticket Id',
      dataIndex: 'Ticket Id',
      key: 'Ticket Id'
    }
  ];

  return (
    <div style={{ minHeight: window.innerHeight - 173, padding: '30px' }}>
      <div style={{ marginTop: '2%' }}>
        <StyledTable size="small"
          columns={maximoCol}
          
          pagination={
            maximoNotification.length > 10
              ? { pageSize: 10 }
              : false
          }
          dataSource={maximoNotification}
        />
      </div>
    </div>
  );
};

export default MaximoNotification;
